document.addEventListener("DOMContentLoaded", function () {

  const openBtn = document.getElementById("atha-open-size-chart");
  const modal = document.getElementById("atha-size-chart-modal");

  if (!openBtn || !modal) return;

  const overlay = modal.querySelector(".atha-size-chart-overlay");
  const closeBtn = modal.querySelector(".atha-size-chart-close");

  openBtn.addEventListener("click", function () {
    modal.classList.add("active");
    document.body.style.overflow = "hidden";
  });

  function closeModal() {
    modal.classList.remove("active");
    document.body.style.overflow = "";
  }

  closeBtn.addEventListener("click", closeModal);
  overlay.addEventListener("click", closeModal);

  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape") {
      closeModal();
    }
  });

});


